<lib-quick-link
  [contextId]="details.privateSessionId"
  [context]="'PrivateSession'"
></lib-quick-link>
została odwiedzona przez
{{ ob | objectLabel: details.organizationClientId | async }}


<lib-quick-cover
  [contextId]="details.privateSessionId"
  [context]="'PrivateSession'"
  [maxSize]="2048"
></lib-quick-cover>
